import {
  GAD_SOURCE,
  GCLID,
  REGION,
  REGION_ID,
  SRSLTID,
  STORE,
  STORE_CODE,
} from '../constants/queries';

export default function clearRegion() {
  const url = new URL(window.location.href);
  url.searchParams.delete(REGION);
  url.searchParams.delete(REGION_ID);
  url.searchParams.delete(STORE_CODE);
  url.searchParams.delete(STORE);
  url.searchParams.delete(GAD_SOURCE);
  url.searchParams.delete(GCLID);
  url.searchParams.delete(SRSLTID);

  window.location.replace(url.href);
}
